import type { CartItemType } from '@/store/types/cart'
import { sendGTMEvent } from '@next/third-parties/google'
import type { GtmGlobalStoreProps } from '../../useGTM'
import { getEcommerceObjectForRemoval } from '../../helpers/getEccomerceObjectForRemoval'
import { gtmClearEcommerceData } from '../../helpers/clearEcommerceData'

export type RemoveCartEventLocationsType = 'cart_decrease_item_quantity'

export type GtmRemoveFromCartProps = {
  cartItem: CartItemType
  qty: number
  event_location: RemoveCartEventLocationsType
}

export const gtmRemoveFromCart = ({
  globalStore,
  cartItem,
  qty,
  event_location,
}: GtmRemoveFromCartProps & GtmGlobalStoreProps) => {
  if (!cartItem) return

  const uuid = crypto.randomUUID()

  gtmClearEcommerceData()

  sendGTMEvent({
    event: 'remove_from_cart',
    event_id: uuid,
    ecommerce: getEcommerceObjectForRemoval({
      globalStore,
      cart: [cartItem],
      event_location,
      qty,
    }),
  })
}
